import React from 'react'
import { Link } from 'react-router-dom'
import * as bs4 from 'reactstrap'
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import * as MdIcon from 'react-icons/md'
import { Collapse } from 'reactstrap'

import { withRouter } from "react-router";

class Navbar extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			size: 0,
			nav: '',
			openNav: false,
			changeNav: '',
			mainMenu: '',
		}
	}

	toggleNavbar = () => {
		console.log(' toggleNavbar ')
		this.setState({ openNav: !this.state.openNav })
	}

	componentDidMount = () => {
		window.addEventListener('resize', this.resize.bind(this))
		this.resize();
	}

	resize() {
		// console.log(this.state.size)
		this.setState({ size: window.innerWidth })
	}

	ChangeNav = (type, menu) => {
		if (type === 'Flim') {
			this.props.history.push('/Flim')
		} else {
			this.props.history.push('/Acc')
		}
		this.setState({ changeNav: type, mainMenu: menu })

		// let _nav;
		// let departmentRole = localStorage.getItem("DepartmentNo");
		// if (departmentRole === 'D11' || departmentRole === 'D10') {
		// 	if (type === 'Flim') {
		// 		_nav =
		// 			<div><bs4.Navbar bg="light" light expand="lg" style={{ background: '#61ba52', width: '100%', height: 80 }}>
		// 				<bs4.NavbarBrand style={{ fontSize: '35px', marginLeft: 20, marginRight: 50, color: '#FFF', fontWeight: 600 }}>
		// 					Product Flim <img src={require('../Icon/checkout.png')} style={{ width: '60px', height: '50px' }} />
		// 				</bs4.NavbarBrand>
		// 				<bs4.NavbarToggler onClick={() => this.toggleNavbar()} />
		// 				<Collapse navbar isOpen={this.state.openNav}>
		// 					<bs4.Nav className="mr-auto" navbar>
		// 						<bs4.Nav className="mr-auto" navbar>
		// 							<bs4.NavItem style={{ fontSize: '18px', marginRight: 30 }}>
		// 								{this.props.menu === 'Flim_CreateCode'
		// 									? <bs4.NavLink href="/Flim/CreateCode" style={{ fontSize: '20px', fontWeight: 600, color: '#FFF' }}>Create Code</bs4.NavLink>
		// 									: <bs4.NavLink href="/Flim/CreateCode" style={{ fontSize: '18px' }}>Create Code</bs4.NavLink>
		// 								}
		// 							</bs4.NavItem>
		// 							<bs4.NavItem style={{ fontSize: '18px', marginRight: 30 }}>
		// 								{this.props.menu === 'Flim_PreviewItem'
		// 									? <bs4.NavLink href="/Flim/PreviewItem" style={{ fontSize: '20px', fontWeight: 600, color: '#FFF' }}>Preview Item</bs4.NavLink>
		// 									: <bs4.NavLink href="/Flim/PreviewItem" style={{ fontSize: '18px' }}>Preview Item</bs4.NavLink>
		// 								}
		// 							</bs4.NavItem>
		// 							<bs4.NavItem style={{ fontSize: '18px', marginRight: 30 }}>
		// 								{this.props.menu === 'Flim_CreateBomVer'
		// 									? <bs4.NavLink href="/Flim/CreateBomVer" style={{ fontSize: '20px', fontWeight: 600, color: '#FFF' }}>Create Bom</bs4.NavLink>
		// 									: <bs4.NavLink href="/Flim/CreateBomVer" style={{ fontSize: '18px' }}>Create Bom</bs4.NavLink>
		// 								}
		// 							</bs4.NavItem>
		// 							<bs4.NavItem style={{ fontSize: '18px', marginRight: 30 }}>
		// 								{this.props.menu === 'Flim_PreviewBomVer'
		// 									? <bs4.NavLink href="/Flim/PreviewBomVer" style={{ fontSize: '20px', fontWeight: 600, color: '#FFF' }}>Preview BomVersion</bs4.NavLink>
		// 									: <bs4.NavLink href="/Flim/PreviewBomVer" style={{ fontSize: '18px' }}>Preview BomVersion</bs4.NavLink>
		// 								}
		// 							</bs4.NavItem>
		// 							<bs4.NavItem style={{ fontSize: '18px', marginRight: 30 }}>
		// 								{this.props.menu === 'Flim_PreviewBomLine'
		// 									? <bs4.NavLink href="/Flim/PreviewBomLine" style={{ fontSize: '20px', fontWeight: 600, color: '#FFF' }}>Preview BomLine</bs4.NavLink>
		// 									: <bs4.NavLink href="/Flim/PreviewBomLine" style={{ fontSize: '18px' }}>Preview BomLine</bs4.NavLink>
		// 								}
		// 							</bs4.NavItem>
		// 							<bs4.UncontrolledDropdown nav inNavbar style={{ fontSize: '18px', marginRight: 30 }}>
		// 								{this.props.menu === 'Flim_MasterBomLine'
		// 									? <bs4.DropdownToggle nav caret style={{ fontSize: '20px', fontWeight: 600, color: '#FFF' }}>Data Master</bs4.DropdownToggle>
		// 									: <bs4.DropdownToggle nav caret>Data Master</bs4.DropdownToggle>
		// 								}
		// 								<bs4.DropdownMenu right>
		// 									<bs4.DropdownItem href="/Flim/MasterBomLine" style={{ fontSize: '17px' }}>
		// 										ข้อมูล Master BomLine
		//                                 </bs4.DropdownItem>
		// 									<bs4.DropdownItem href="/Flim/MasterFocusTrade" style={{ fontSize: '17px' }}>
		// 										ข้อมูล Focus/Trade
		//                                 </bs4.DropdownItem>
		// 									<bs4.DropdownItem href="/Flim/MasterStandard" style={{ fontSize: '17px' }}>
		// 										ข้อมูล Standard
		//                                 </bs4.DropdownItem>
		// 									<bs4.DropdownItem href="/Flim/MasterWerehouse" style={{ fontSize: '17px' }}>
		// 										ข้อมูล Werehouse
		//                                 </bs4.DropdownItem>
		// 									<bs4.DropdownItem href="/Flim/MasterOption" style={{ fontSize: '17px' }}>
		// 										ข้อมูล Option ต่างๆ
		//                                 </bs4.DropdownItem>
		// 									<bs4.DropdownItem href="/Flim/MasterDataMin" style={{ fontSize: '17px' }}>
		// 										ข้อมูล ค่ากลาง
		//                                 </bs4.DropdownItem>
		// 								</bs4.DropdownMenu>
		// 							</bs4.UncontrolledDropdown>
		// 							<bs4.UncontrolledDropdown nav inNavbar style={{ fontSize: '18px', marginRight: 30 }}>
		// 								<bs4.DropdownToggle nav caret>Product Info</bs4.DropdownToggle>
		// 								<bs4.DropdownMenu center>
		// 									<bs4.NavItem style={{ fontSize: '18px', marginRight: 30 }}>
		// 										<bs4.NavLink href="/Flim/ProductInfoTable" style={{ fontSize: '17px' }}>Product Management</bs4.NavLink>
		// 									</bs4.NavItem>
		// 									<bs4.NavItem style={{ fontSize: '18px', marginRight: 30 }}>
		// 										<bs4.NavLink href="/Flim/ManageProductImageGroup" style={{ fontSize: '17px' }}>Upload By Group</bs4.NavLink>
		// 									</bs4.NavItem>
		// 									<bs4.NavItem style={{ fontSize: '18px', marginRight: 30 }}>
		// 										<bs4.NavLink href="/Flim/ProductInfoGroup" style={{ fontSize: '17px' }}>Product Info By Group</bs4.NavLink>
		// 									</bs4.NavItem>
		// 								</bs4.DropdownMenu>
		// 							</bs4.UncontrolledDropdown>
		// 						</bs4.Nav>
		// 					</bs4.Nav>
		// 					<bs4.Nav className="ml-auto" navbar style={{ fontSize: '30px', marginRight: 20 }}>
		// 						<bs4.UncontrolledDropdown inNavbar >
		// 							<bs4.DropdownToggle nav caret style={{ fontSize: '30px', color: '#FFF' }}>
		// 								ITEM MASTER
		//                         </bs4.DropdownToggle>
		// 							<bs4.DropdownMenu right>
		// 								<bs4.DropdownItem onClick={() => this.ChangeNav('Flim', 'Flim_CreateCode')}>
		// 									Product Flim
		//                             </bs4.DropdownItem>
		// 								<bs4.DropdownItem onClick={() => this.ChangeNav('Acc', 'Acc_CreatItem')}>
		// 									Product Acc
		//                             </bs4.DropdownItem>
		// 								<bs4.DropdownItem href="/">
		// 									Logout
		//                             </bs4.DropdownItem>
		// 							</bs4.DropdownMenu>
		// 						</bs4.UncontrolledDropdown>
		// 					</bs4.Nav>
		// 				</Collapse>
		// 			</bs4.Navbar>
		// 			</div>
		// 	} else {
		// 		_nav =
		// 			<div>
		// 				<bs4.Navbar bg="light" light expand="lg" style={{ background: '#fec23e', width: '100%', height: 80 }}>
		// 					<bs4.NavbarBrand style={{ fontSize: '35px', marginLeft: 20, marginRight: 50, color: '#000', fontWeight: 600 }}>
		// 						Product Acc <img src={require('../Icon/trolley.png')} style={{ width: '50px', height: '50px' }} />
		// 					</bs4.NavbarBrand>
		// 					<bs4.NavbarToggler onClick={() => this.toggleNavbar()} />
		// 					<Collapse navbar isOpen={this.state.openNav}>
		// 						<bs4.Nav className="mr-auto" navbar>
		// 							<bs4.NavItem style={{ marginRight: 30 }}>
		// 								{this.props.menu === 'Acc_CreatItem' || menu === 'Acc_CreatItem'
		// 									? <bs4.NavLink href="/Acc/CreateItem" style={{ fontSize: '20px', color: '#000', fontWeight: 600 }}>Create Item</bs4.NavLink>
		// 									: <bs4.NavLink href="/Acc/CreateItem" style={{ fontSize: '18px', color: '#FFF' }}>Create Item</bs4.NavLink>
		// 								}
		// 							</bs4.NavItem>
		// 							<bs4.NavItem style={{ marginRight: 30 }}>
		// 								{this.props.menu === 'Acc_PreviewItem' || menu === 'Acc_PreviewItem'
		// 									? <bs4.NavLink href="/Acc/PreviewItem" style={{ fontSize: '20px', color: '#000', fontWeight: 600 }}>Preview Item</bs4.NavLink>
		// 									: <bs4.NavLink href="/Acc/PreviewItem" style={{ fontSize: '18px', color: '#FFF' }}>Preview Item</bs4.NavLink>
		// 								}
		// 							</bs4.NavItem>
		// 							<bs4.NavItem style={{ marginRight: 30 }}>
		// 								{this.props.menu === 'Acc_CreateBom' || menu === 'Acc_CreateBom'
		// 									? <bs4.NavLink href="/Acc/CreateBom" style={{ fontSize: '20px', color: '#000', fontWeight: 600 }}>Create Bom</bs4.NavLink>
		// 									: <bs4.NavLink href="/Acc/CreateBom" style={{ fontSize: '18px', color: '#FFF' }}>Create Bom</bs4.NavLink>
		// 								}
		// 							</bs4.NavItem>
		// 							<bs4.NavItem style={{ marginRight: 30 }}>
		// 								{this.props.menu === 'Acc_PreviewBomVer' || menu === 'Acc_PreviewBomVer'
		// 									? <bs4.NavLink href="/Acc/PreviewBomVer" style={{ fontSize: '20px', color: '#000', fontWeight: 600 }}>Preview Bom</bs4.NavLink>
		// 									: <bs4.NavLink href="/Acc/PreviewBomVer" style={{ fontSize: '18px', color: '#FFF' }}>Preview Bom</bs4.NavLink>
		// 								}
		// 							</bs4.NavItem>
		// 							<bs4.UncontrolledDropdown nav inNavbar style={{ fontSize: '18px', marginRight: 30 }}>
		// 								{this.props.menu === 'Acc_MasterBomLine'
		// 									? <bs4.DropdownToggle nav caret style={{ fontSize: '20px', fontWeight: 600, color: '#000' }}>Data Master</bs4.DropdownToggle>
		// 									: <bs4.DropdownToggle nav caret style={{ fontSize: '18px', color: '#FFF' }}>Data Master</bs4.DropdownToggle>
		// 								}
		// 								<bs4.DropdownMenu right>
		// 									<bs4.DropdownItem href="/Acc/MasterOption" style={{ fontSize: '17px' }}>
		// 										ข้อมูล Option ต่างๆ
		//                                 </bs4.DropdownItem>
		// 								</bs4.DropdownMenu>
		// 							</bs4.UncontrolledDropdown>
		// 						</bs4.Nav>
		// 						<bs4.Nav className="ml-auto" navbar style={{ fontSize: '30px', marginRight: 20 }}>
		// 							<bs4.UncontrolledDropdown inNavbar >
		// 								<bs4.DropdownToggle nav caret style={{ fontSize: '30px', color: '#000' }}>
		// 									ITEM MASTER
		//                         </bs4.DropdownToggle>
		// 								<bs4.DropdownMenu right>
		// 									<bs4.DropdownItem onClick={() => this.ChangeNav('Flim', 'Flim_CreateCode')}>
		// 										Product Flim
		//                             </bs4.DropdownItem>
		// 									<bs4.DropdownItem onClick={() => this.ChangeNav('Acc', 'Acc_CreatItem')}>
		// 										Product Acc
		//                             </bs4.DropdownItem>
		// 									<bs4.DropdownItem href="/">
		// 										Logout
		//                             </bs4.DropdownItem>
		// 								</bs4.DropdownMenu>
		// 							</bs4.UncontrolledDropdown>
		// 						</bs4.Nav>
		// 					</Collapse>
		// 				</bs4.Navbar>
		// 			</div>
		// 	}
		// } else {
		// 	_nav =
		// 		<div>
		// 			<bs4.Navbar bg="light" light expand="lg" style={{ background: '#61ba52', width: '100%', height: 80 }}>
		// 				<bs4.NavbarBrand style={{ fontSize: '35px', marginLeft: 20, marginRight: 50, color: '#FFF', fontWeight: 600 }}>
		// 					Product Flim <img src={require('../Icon/checkout.png')} style={{ width: '60px', height: '50px' }} />
		// 				</bs4.NavbarBrand>
		// 				<bs4.NavbarToggler onClick={() => this.toggleNavbar()} />
		// 				<Collapse navbar isOpen={this.state.openNav}>
		// 					<bs4.Nav className="mr-auto" navbar>
		// 						<bs4.UncontrolledDropdown nav inNavbar style={{ fontSize: '18px', marginRight: 30 }}>
		// 							<bs4.DropdownToggle nav caret>Product Info</bs4.DropdownToggle>
		// 							<bs4.DropdownMenu center>
		// 								<bs4.NavItem style={{ fontSize: '18px', marginRight: 30 }}>
		// 									<bs4.NavLink href="/Flim/ProductInfoTable" style={{ fontSize: '17px' }}>Product Management</bs4.NavLink>
		// 								</bs4.NavItem>
		// 								<bs4.NavItem style={{ fontSize: '18px', marginRight: 30 }}>
		// 									<bs4.NavLink href="/Flim/ProductInfoGroup" style={{ fontSize: '17px' }}>Product Info By Group</bs4.NavLink>
		// 								</bs4.NavItem>
		// 							</bs4.DropdownMenu>
		// 						</bs4.UncontrolledDropdown>
		// 					</bs4.Nav>
		// 					<bs4.Nav className="ml-auto" navbar style={{ fontSize: '30px', marginRight: 20 }}>
		// 						<bs4.UncontrolledDropdown inNavbar >
		// 							<bs4.DropdownToggle nav caret style={{ fontSize: '30px', color: '#FFF' }}>
		// 								ITEM MASTER
		//                 </bs4.DropdownToggle>
		// 							<bs4.DropdownMenu right>

		// 								<bs4.DropdownItem href="/">
		// 									Logout
		//                     </bs4.DropdownItem>
		// 							</bs4.DropdownMenu>
		// 						</bs4.UncontrolledDropdown>
		// 					</bs4.Nav>
		// 				</Collapse>
		// 			</bs4.Navbar >
		// 		</div>
		// }


		// this.setState({ nav: _nav })
	}

	renderMenuFilm = () => {
		return (
			<div><bs4.Navbar bg="light" light expand="lg" style={{ background: '#61ba52', width: '100%' }}>
				<bs4.NavbarBrand style={{ fontSize: '35px', marginLeft: 20, marginRight: 50, color: '#FFF', fontWeight: 600 }}>
					Product Flim <img src={require('../Icon/checkout.png')} style={{ width: '60px', height: '50px' }} />
				</bs4.NavbarBrand>
				<bs4.NavbarToggler onClick={() => this.toggleNavbar()} />
				<Collapse navbar isOpen={this.state.openNav}>
					<bs4.Nav className="mr-auto" navbar>
						<bs4.Nav className="mr-auto" navbar>
							<bs4.NavItem style={{ fontSize: '18px', marginRight: 30 }}>
								{this.props.menu === 'Flim_CreateCode'
									? <bs4.NavLink href="/Flim/CreateCode" style={{ fontSize: '20px', fontWeight: 600, color: '#FFF' }}>Create Code</bs4.NavLink>
									: <bs4.NavLink href="/Flim/CreateCode" style={{ fontSize: '18px' }}>Create Code</bs4.NavLink>
								}
							</bs4.NavItem>
							<bs4.NavItem style={{ fontSize: '18px', marginRight: 30 }}>
								{this.props.menu === 'Flim_PreviewItem'
									? <bs4.NavLink href="/Flim/PreviewItem" style={{ fontSize: '20px', fontWeight: 600, color: '#FFF' }}>Preview Item</bs4.NavLink>
									: <bs4.NavLink href="/Flim/PreviewItem" style={{ fontSize: '18px' }}>Preview Item</bs4.NavLink>
								}
							</bs4.NavItem>
							<bs4.NavItem style={{ fontSize: '18px', marginRight: 30 }}>
								{this.props.menu === 'Flim_CreateBomVer'
									? <bs4.NavLink href="/Flim/CreateBomVer" style={{ fontSize: '20px', fontWeight: 600, color: '#FFF' }}>Create Bom</bs4.NavLink>
									: <bs4.NavLink href="/Flim/CreateBomVer" style={{ fontSize: '18px' }}>Create Bom</bs4.NavLink>
								}
							</bs4.NavItem>
							<bs4.NavItem style={{ fontSize: '18px', marginRight: 30 }}>
								{this.props.menu === 'Flim_PreviewBomVer'
									? <bs4.NavLink href="/Flim/PreviewBomVer" style={{ fontSize: '20px', fontWeight: 600, color: '#FFF' }}>Preview BomVersion</bs4.NavLink>
									: <bs4.NavLink href="/Flim/PreviewBomVer" style={{ fontSize: '18px' }}>Preview BomVersion</bs4.NavLink>
								}
							</bs4.NavItem>
							<bs4.NavItem style={{ fontSize: '18px', marginRight: 30 }}>
								{this.props.menu === 'Flim_PreviewBomLine'
									? <bs4.NavLink href="/Flim/PreviewBomLine" style={{ fontSize: '20px', fontWeight: 600, color: '#FFF' }}>Preview BomLine</bs4.NavLink>
									: <bs4.NavLink href="/Flim/PreviewBomLine" style={{ fontSize: '18px' }}>Preview BomLine</bs4.NavLink>
								}
							</bs4.NavItem>
							<bs4.UncontrolledDropdown nav inNavbar style={{ fontSize: '18px', marginRight: 30 }}>
								{this.props.menu === 'Flim_MasterBomLine'
									? <bs4.DropdownToggle nav caret style={{ fontSize: '20px', fontWeight: 600, color: '#FFF' }}>Data Master</bs4.DropdownToggle>
									: <bs4.DropdownToggle nav caret>Data Master</bs4.DropdownToggle>
								}
								<bs4.DropdownMenu right>
									<bs4.DropdownItem href="/Flim/MasterBomLine" style={{ fontSize: '17px' }}>
										ข้อมูล Master BomLine
									</bs4.DropdownItem>
									<bs4.DropdownItem href="/Flim/MasterFocusTrade" style={{ fontSize: '17px' }}>
										ข้อมูล Focus/Trade
									</bs4.DropdownItem>
									<bs4.DropdownItem href="/Flim/MasterStandard" style={{ fontSize: '17px' }}>
										ข้อมูล Standard
									</bs4.DropdownItem>
									<bs4.DropdownItem href="/Flim/MasterWerehouse" style={{ fontSize: '17px' }}>
										ข้อมูล Werehouse
									</bs4.DropdownItem>
									<bs4.DropdownItem href="/Flim/MasterOption" style={{ fontSize: '17px' }}>
										ข้อมูล Option ต่างๆ
									</bs4.DropdownItem>
									<bs4.DropdownItem href="/Flim/MasterDataMin" style={{ fontSize: '17px' }}>
										ข้อมูล ค่ากลาง
									</bs4.DropdownItem>
								</bs4.DropdownMenu>
							</bs4.UncontrolledDropdown>
							<bs4.UncontrolledDropdown nav inNavbar style={{ fontSize: '18px', marginRight: 30 }}>
								{this.props.menu === 'Film_DisplayTableProductImage'
									? <bs4.DropdownToggle nav caret style={{ fontSize: '20px', fontWeight: 600, color: '#FFF' }}>Product Management</bs4.DropdownToggle>
									: <bs4.DropdownToggle nav caret>Product Management</bs4.DropdownToggle>
								}
								<bs4.DropdownMenu right>
									<bs4.DropdownItem href="/Flim/ProductInfoTable" style={{ fontSize: '17px' }}>Product Management</bs4.DropdownItem>
									<bs4.DropdownItem href="/Flim/ManageProductImageGroup" style={{ fontSize: '17px' }}>Product Group Management</bs4.DropdownItem>
									<bs4.DropdownItem href="/Flim/ProductInfoGroup" style={{ fontSize: '17px' }}>Product Group Info</bs4.DropdownItem>
									<bs4.DropdownItem href="/Flim/SameModelInfo" style={{ fontSize: '17px' }}>Compatible Models Management</bs4.DropdownItem>
								</bs4.DropdownMenu>
							</bs4.UncontrolledDropdown>
						</bs4.Nav>
					</bs4.Nav>
					<bs4.Nav className="ml-auto" navbar style={{ fontSize: '30px', marginRight: 20 }}>
						<bs4.UncontrolledDropdown inNavbar >
							<bs4.DropdownToggle nav caret style={{ fontSize: '30px', color: '#FFF' }}>
								ITEM MASTER
							</bs4.DropdownToggle>
							<bs4.DropdownMenu right>
								<bs4.DropdownItem onClick={() => this.ChangeNav('Flim', 'Flim_CreateCode')}>
									Product Flim
								</bs4.DropdownItem>
								<bs4.DropdownItem onClick={() => this.ChangeNav('Acc', 'Acc_CreatItem')}>
									Product Acc
								</bs4.DropdownItem>
								<bs4.DropdownItem href="/">
									Logout
								</bs4.DropdownItem>
							</bs4.DropdownMenu>
						</bs4.UncontrolledDropdown>
					</bs4.Nav>
				</Collapse>
			</bs4.Navbar>
			</div>
		)
	}

	renderMenuAcc = () => {
		let menu = !!this.state.mainMenu ? this.state.mainMenu : ''
		return (
			<div>
				<bs4.Navbar bg="light" light expand="lg" style={{ background: '#fec23e', width: '100%' }}>
					<bs4.NavbarBrand style={{ fontSize: '35px', marginLeft: 20, marginRight: 50, color: '#000', fontWeight: 600 }}>
						Product Acc <img src={require('../Icon/trolley.png')} style={{ width: '50px', height: '50px' }} />
					</bs4.NavbarBrand>
					<bs4.NavbarToggler onClick={() => this.toggleNavbar()} />
					<Collapse navbar isOpen={this.state.openNav}>
						<bs4.Nav className="mr-auto" navbar>
							<bs4.NavItem style={{ marginRight: 30 }}>
								{this.props.menu === 'Acc_CreatItem' || menu === 'Acc_CreatItem'
									? <bs4.NavLink href="/Acc/CreateItem" style={{ fontSize: '20px', color: '#000', fontWeight: 600 }}>Create Item</bs4.NavLink>
									: <bs4.NavLink href="/Acc/CreateItem" style={{ fontSize: '18px', color: '#FFF' }}>Create Item</bs4.NavLink>
								}
							</bs4.NavItem>
							<bs4.NavItem style={{ marginRight: 30 }}>
								{this.props.menu === 'Acc_PreviewItem' || menu === 'Acc_PreviewItem'
									? <bs4.NavLink href="/Acc/PreviewItem" style={{ fontSize: '20px', color: '#000', fontWeight: 600 }}>Preview Item</bs4.NavLink>
									: <bs4.NavLink href="/Acc/PreviewItem" style={{ fontSize: '18px', color: '#FFF' }}>Preview Item</bs4.NavLink>
								}
							</bs4.NavItem>
							<bs4.NavItem style={{ marginRight: 30 }}>
								{this.props.menu === 'Acc_CreateBom' || menu === 'Acc_CreateBom'
									? <bs4.NavLink href="/Acc/CreateBom" style={{ fontSize: '20px', color: '#000', fontWeight: 600 }}>Create Bom</bs4.NavLink>
									: <bs4.NavLink href="/Acc/CreateBom" style={{ fontSize: '18px', color: '#FFF' }}>Create Bom</bs4.NavLink>
								}
							</bs4.NavItem>
							<bs4.NavItem style={{ marginRight: 30 }}>
								{this.props.menu === 'Acc_PreviewBomVer' || menu === 'Acc_PreviewBomVer'
									? <bs4.NavLink href="/Acc/PreviewBomVer" style={{ fontSize: '20px', color: '#000', fontWeight: 600 }}>Preview Bom</bs4.NavLink>
									: <bs4.NavLink href="/Acc/PreviewBomVer" style={{ fontSize: '18px', color: '#FFF' }}>Preview Bom</bs4.NavLink>
								}
							</bs4.NavItem>
							<bs4.UncontrolledDropdown nav inNavbar style={{ fontSize: '18px', marginRight: 30 }}>
								{this.props.menu === 'Acc_MasterBomLine' || menu === 'Acc_MasterBomLine'
									? <bs4.DropdownToggle nav caret style={{ fontSize: '20px', fontWeight: 600, color: '#000' }}>Data Master</bs4.DropdownToggle>
									: <bs4.DropdownToggle nav caret style={{ fontSize: '18px', color: '#FFF' }}>Data Master</bs4.DropdownToggle>
								}
								<bs4.DropdownMenu right>
									<bs4.DropdownItem href="/Acc/MasterOption" style={{ fontSize: '17px' }}>
										ข้อมูล Option ต่างๆ
									</bs4.DropdownItem>
								</bs4.DropdownMenu>
							</bs4.UncontrolledDropdown>
						</bs4.Nav>
						<bs4.Nav className="ml-auto" navbar style={{ fontSize: '30px', marginRight: 20 }}>
							<bs4.UncontrolledDropdown inNavbar >
								<bs4.DropdownToggle nav caret style={{ fontSize: '30px', color: '#000' }}>
									ITEM MASTER
								</bs4.DropdownToggle>
								<bs4.DropdownMenu right>
									<bs4.DropdownItem onClick={() => this.ChangeNav('Flim', 'Flim_CreateCode')}>
										Product Flim
									</bs4.DropdownItem>
									<bs4.DropdownItem onClick={() => this.ChangeNav('Acc', 'Acc_CreatItem')}>
										Product Acc
									</bs4.DropdownItem>
									<bs4.DropdownItem href="/">
										Logout
									</bs4.DropdownItem>
								</bs4.DropdownMenu>
							</bs4.UncontrolledDropdown>
						</bs4.Nav>
					</Collapse>
				</bs4.Navbar>
			</div>
		)
	}

	renderNavInside = () => {
		let nav = this.state.changeNav !== '' ? this.state.changeNav : this.props.nav
		let departmentRole = localStorage.getItem("DepartmentNo");
		let ID_User = localStorage.getItem("ID_User");

		if (departmentRole === 'D11' || departmentRole === 'D10' || departmentRole === 'Z01' || departmentRole === 'D04') {
			if (nav === 'Flim') {
				return this.renderMenuFilm()
			} else {
				return this.renderMenuAcc()
			}
		} else if (ID_User === 'DP58192' || ID_User === 'DP63303') {
			// console.log('departmentRole',departmentRole)
			// console.log('ID_User',ID_User)
			return this.renderMenuAcc()
		} else {
			return this.renderMenuGuest()
		}
	}

	renderMenuGuest = () => {
		return (
			<div>
				<bs4.Navbar bg="light" light expand="lg" style={{ background: '#61ba52', width: '100%' }}>
					<bs4.NavbarBrand style={{ fontSize: '35px', marginLeft: 20, marginRight: 50, color: '#FFF', fontWeight: 600 }}>
						Product Flim <img src={require('../Icon/checkout.png')} style={{ width: '60px', height: '50px' }} />
					</bs4.NavbarBrand>
					<bs4.NavbarToggler onClick={() => this.toggleNavbar()} />
					<Collapse navbar isOpen={this.state.openNav}>
						<bs4.Nav className="mr-auto" navbar>
							<bs4.UncontrolledDropdown nav inNavbar style={{ fontSize: '18px', marginRight: 30 }}>
								{this.props.menu === 'Film_DisplayTableProductImage'
									? <bs4.DropdownToggle nav caret style={{ fontSize: '20px', fontWeight: 600, color: '#FFF' }}>Product Management</bs4.DropdownToggle>
									: <bs4.DropdownToggle nav caret>Product Management</bs4.DropdownToggle>
								}
								<bs4.DropdownMenu right>
									<bs4.DropdownItem href="/Flim/ProductInfoTable" style={{ fontSize: '17px' }}>Product Management</bs4.DropdownItem>
									<bs4.DropdownItem href="/Flim/ProductInfoGroup" style={{ fontSize: '17px' }}>Product Group Info</bs4.DropdownItem>
									<bs4.DropdownItem href="/Flim/SameModelInfo" style={{ fontSize: '17px' }}>Compatible Models Management</bs4.DropdownItem>
								</bs4.DropdownMenu>
							</bs4.UncontrolledDropdown>
						</bs4.Nav>
						<bs4.Nav className="ml-auto" navbar style={{ fontSize: '30px', marginRight: 20 }}>
							<bs4.UncontrolledDropdown inNavbar >
								<bs4.DropdownToggle nav caret style={{ fontSize: '30px', color: '#FFF' }}>
									ITEM MASTER
								</bs4.DropdownToggle>
								<bs4.DropdownMenu right>

									<bs4.DropdownItem href="/">
										Logout
									</bs4.DropdownItem>
								</bs4.DropdownMenu>
							</bs4.UncontrolledDropdown>
						</bs4.Nav>
					</Collapse>
				</bs4.Navbar >
			</div>
		)
	}

	render() {

		return (
			<div>
				{this.renderNavInside()}
			</div>
		)

	}
}

export default withRouter(Navbar)
